import { ReactNode } from "react";

import { DialogTitle, DialogTitleProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { layout } from "theme/tokens/semantic/layout";

interface IBasicDialogTitle extends DialogTitleProps {
  withBoxShadow?: boolean; // can be combined with "dividers" prop on BasicDialogContent
  children: ReactNode;
  divider?: boolean;
}

const DIALOG_TITLE_PADDING = `${layout.dialog.titlePaddingY}px ${layout.dialog.paddingX}px`;

const useStyles = makeStyles({
  root: ({ withBoxShadow, divider }: Partial<IBasicDialogTitle>) => ({
    // `&&` beats MUI DialogTitle emotion padding so token inset actually applies.
    "&&": {
      padding: DIALOG_TITLE_PADDING,
    },
    ...(withBoxShadow && { boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.1)" }),
    ...(divider && { borderBottom: `solid 1px #EAEEF2` }),
  }),
});

const BasicDialogTitle = ({
  children,
  withBoxShadow = true,
  divider,
  ...props
}: IBasicDialogTitle) => {
  const classes = useStyles({ withBoxShadow, divider });
  return (
    <DialogTitle classes={classes} {...props}>
      {children}
    </DialogTitle>
  );
};

export default BasicDialogTitle;
